import React, { useState } from "react";
import CreateAccount from "./CreateAccount";
import HierarchyView from "../utils/HierarchyView";
import "./Members.css";

const Members = ({ showToast }) => {
  const [isCreateOpen, setIsCreateOpen] = useState(false);

  const toggleCreate = () => setIsCreateOpen((prev) => !prev);

  return (
    <div className="members-container">
      {/* Hierarchy is always visible on top */}
      <HierarchyView showToast={showToast} />

      {/* Collapsible "Create Member" section */}
      <div className="create-toggle" onClick={toggleCreate}>
        <h4 className="create-header">
          Create Member
          <span className={`carrot ${isCreateOpen ? "open" : ""}`}>{'>'}</span>
        </h4>
        {isCreateOpen && (
          <div className="create-section">
            <CreateAccount showToast={showToast} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Members;
